import { styled, keyframes } from '@mui/material/styles';
import { Box } from '@mui/material';
import audioEffectImage from '@src/assets/images/audio-effect.png';
import { COLOR } from '@src/styles/color';

const CIRCLE_SIZE = 200;
const SEGMENT_TOP_OFFSET = 12;
const SEGMENT_TRANSFORM_ORIGIN_Y = CIRCLE_SIZE / 2 - SEGMENT_TOP_OFFSET; // keep rotation center aligned
const RING_OVERLAY_SIZE = CIRCLE_SIZE + 3;

const segmentsEnter = keyframes`
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.92);
  }
  100% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
`;
const labelsEnter = keyframes`
  0% {
    opacity: 0;
    transform: translateY(8px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const StyledAudioEffectProgress = styled(Box)`
  position: relative;
  width: ${CIRCLE_SIZE}px;
  height: ${CIRCLE_SIZE}px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const GradientCircle = styled(Box)`
  position: absolute;
  width: ${CIRCLE_SIZE}px;
  height: ${CIRCLE_SIZE}px;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-image: url(${audioEffectImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
`;

export const SegmentsContainer = styled(Box)`
  position: absolute;
  width: ${CIRCLE_SIZE}px;
  height: ${CIRCLE_SIZE}px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
  opacity: 0;
  animation: ${segmentsEnter} 500ms ease forwards;
`;

export const Segment = styled(Box)`
  position: absolute;
  width: 4px;
  height: 8px;
  background-color: rgba(30, 22, 78, 0.08);
  mix-blend-mode: soft-light;
  opacity: 1;
  border-radius: 12px;
  left: 50%;
  top: ${SEGMENT_TOP_OFFSET}px;
  margin-left: -2px;
  transform-origin: 2px ${SEGMENT_TRANSFORM_ORIGIN_Y}px;
  transform: rotate(${(props) => props.rotation}deg);
  transition: height 0.3s ease, background-color 0.3s ease, opacity 0.3s ease;
  display: ${({ isActive }) => (!isActive ? 'block' : 'none')};
`;

export const RingOverlay = styled(Box)`
  position: absolute;
  width: ${RING_OVERLAY_SIZE}px;
  height: ${RING_OVERLAY_SIZE}px;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  background: radial-gradient(
    circle,
    transparent 0%,
    transparent 47%,
    rgba(255, 255, 255, 1) 48%,
    rgba(255, 255, 255, 1) 100%
  );
  ${({ maskId }) =>
    maskId
      ? `
    mask: url(#${maskId});
    -webkit-mask: url(#${maskId});
  `
      : ''}
  z-index: 2;
`;

export const MaskSvg = styled('svg')`
  position: absolute;
  width: 100%;
  height: 100%;
`;

export const QualityLabelsOverlay = styled('svg')`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
  pointer-events: none;
  z-index: 4;
  opacity: 0;
  animation: ${labelsEnter} 450ms 150ms ease forwards;
`;

export const SvgConnectorPath = styled('path')`
  stroke: rgba(28, 28, 30, 1);
  stroke-width: 0.5;
  fill: none;
`;

export const SvgLabelText = styled('text')`
  font-size: 16px;
  line-height: 20px;
`;

export const SvgLabelTitle = styled('tspan')`
  font-weight: 600;
  fill: ${COLOR.darkGray};
  font-size: 16px;
`;

export const SvgLabelPercentage = styled('tspan')`
  font-weight: 400;
  fill: ${COLOR.label2[64]};
  font-size: 16px;
`;
